import { nanoid } from "nanoid"
import stationSettings from './station-config'

// Bump when defaults change in a way saved settings must pick up (see loadSettings).
export const SETTINGS_VERSION = 2

const defaultSettings = {
  settingsVersion: SETTINGS_VERSION,
  mainSettings: {
    centralSystemUrl: 'wss://dev-ocpp.evsafe.io',
    protocol: 'ws',
    address: 'localhost',
    port: 5000,
    chargePointId: '00000001111',
    OCPPversion: 'ocpp1.6',
    RFIDTag: nanoid(20),
    numberOfConnectors: 2,
  },

  bootNotification: {
    chargePointVendor: 'Elmo',
    chargePointModel: 'Elmo-Virtual1',
    chargePointSerialNumber: 'elm.001.13.1',
    chargeBoxSerialNumber: 'elm.001.13.1.01',
    firmwareVersion: '0.9.87',
    iccid: '',
    imsi: '',
    meterType: 'ELM NQC-ACDC',
    meterSerialNumber: 'elm.001.13.1.01'
  },

  stationSettings: stationSettings.configurationKey,

  simulation: {
    // {id}, {type} and {time} are filled in, e.g. 00000001111_diagnostics_20261029T101500Z.log
    diagnosticFileName: '{id}_{type}_{time}.log',
    diagnosticUploadTime: 0, // extra seconds before each upload attempt
    diagnosticStatus: 'Auto', // Auto: the real upload result; UploadFailed: force a failure
    httpUploadMethod: 'POST',
    firmWareStatus: 'Installed', // Installed: the real result; or force DownloadFailed / InvalidSignature / InstallationFailed
    connectorOneUnlock: 'Unlocked',
    connectorTwoUnlock: 'Unlocked',
    maxPowerW: 11000, // 16 A three-phase
    batteryCapacityWh: 60000,
    initialSoc: 20,
  }
}

export default defaultSettings
